import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '@cpd-app/state';
import * as LicenseActions from './license.actions';
import * as LicenseSelectors from './license.selectors';

@Injectable({
  providedIn: 'root',
})
export class LicenseFacade {
  readonly licenses$ = this.store.pipe(select(LicenseSelectors.selectLicenses));
  readonly licenseCount$ = this.store.pipe(
    select(LicenseSelectors.selectLicenseCount)
  );

  constructor(private store: Store<AppState>) {}

  loadLicenses() {
    this.store.dispatch(LicenseActions.loadLicenses());
  }

  clearLicenses() {
    this.store.dispatch(LicenseActions.clearLicenses());
  }
}
